import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import './PhotoGallery.css';

const PhotoGallery = () => {
  // Array of your images
  const images = [
    {
      src: '/images/gallery/IMG_2062.png',
      alt: 'Professional Window Tinting Work',
      title: 'Automotive Tinting'
    },
    {
      src: '/images/gallery/IMG_2063.jpeg',
      alt: 'Car Window Tinting Result',
      title: 'Premium Tint Installation'
    },
    {
      src: '/images/gallery/IMG_2066.jpeg',
      alt: 'Window Tinting Service',
      title: 'Professional Installation'
    },
    {
      src: '/images/gallery/IMG_2067.jpeg',
      alt: 'Quality Tint Work',
      title: 'Expert Craftsmanship'
    },
    {
      src: '/images/gallery/IMG_2069.jpeg',
      alt: 'Vehicle Tinting',
      title: 'Automotive Specialist'
    },
    {
      src: '/images/gallery/IMG_2071.jpeg',
      alt: 'Window Film Installation',
      title: 'Professional Results'
    },
    {
      src: '/images/gallery/IMG_2073.jpeg',
      alt: 'Tinting Service',
      title: 'Quality Work'
    },
    {
      src: '/images/gallery/IMG_2075.jpeg',
      alt: 'Professional Tinting',
      title: 'Expert Installation'
    },
    {
      src: '/images/gallery/IMG_2081.jpeg',
      alt: 'Window Tint Gallery',
      title: 'Premium Service'
    },
    {
      src: '/images/gallery/IMG_2082.jpeg',
      alt: 'Completed Tinting Work',
      title: 'Satisfied Customer'
    }
  ];

  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(images[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const goToNext = () => {
    const nextIndex = (currentIndex + 1) % images.length;
    setCurrentIndex(nextIndex);
    setSelectedImage(images[nextIndex]);
  };

  const goToPrevious = () => {
    const prevIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(prevIndex);
    setSelectedImage(images[prevIndex]);
  };

  return (
    <section className="photo-gallery">
      <div className="container">
        <div className="gallery-header">
          <h2>Our Work</h2>
          <p>See the quality and precision of our professional window tinting services</p>
        </div>

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {images.map((image, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => openLightbox(index)}
            >
              <img
                src={image.src}
                alt={image.alt}
                loading="lazy"
              />
              <div className="gallery-overlay">
                <h4>{image.title}</h4>
                <p>Click to view</p>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox */}
        {selectedImage && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button className="lightbox-close" onClick={closeLightbox}>
                <X size={24} />
              </button>

              <button className="lightbox-nav lightbox-prev" onClick={goToPrevious}>
                <ChevronLeft size={24} />
              </button>

              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="lightbox-image"
              />

              <button className="lightbox-nav lightbox-next" onClick={goToNext}>
                <ChevronRight size={24} />
              </button>

              <div className="lightbox-info">
                <h3>{selectedImage.title}</h3>
                <p>{currentIndex + 1} of {images.length}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PhotoGallery;
